module.exports = __webpack_public_path__ + "static/media/MenuDropdown.7ca6ffb4.svg";